// Which games show a live demo on their /games/[slug] page, and which
// GameDemoStage scene each one plays. This replaces the old pre-recorded
// video clips: the scenes are real DOM, so they stay sharp at any size and
// can be replayed.
//
// This map is the on/off switch - comment out (or delete) a line to stop
// showing the demo for that game; add a line once a game has a scene worth
// showing. Scene ids are the `game` values GameDemoStage understands.

export const GAME_DEMO_SCENES: Record<string, string> = {
  battleship: 'battleship',
  checkers: 'checkers',
  'box-circuit': 'boxCircuit',
  'raythread-rally': 'raythreadRally',
  'puzzle-together': 'puzzleTogether',
  'connect-4': 'connect4',
  'escape-room-hub': 'escapeRoom',
  'field-agent': 'fieldAgent',
  'gnc-racing': 'racing',
  'horse-race': 'horseRace',
  imposter: 'imposter',
  linklogic: 'linkLogic',
  'mafia-lite': 'mafiaLite',
  'memory-match': 'memoryMatch',
  'mind-sync': 'mindSync',
  'one-word-story': 'oneWordStory',
  pictionary: 'pictionary',
  'pixel-tennis': 'pong',
  'quick-minds': 'quickMinds',
  'rps-showdown': 'rps',
  'silent-code': 'silentCode',
  'tic-tac-toe': 'tictactoe',
  'truth-or-dare': 'truthOrDare',
  'word-unscramble': 'wordUnscramble',
  'would-you-rather': 'wouldYouRather',

  // Fallback / standard demo integrations
  chess: 'chess',
  minesweeper: 'minesweeper',
  'blind-maze': 'blindMaze',
  'guess-my-number': 'guessMyNumber',
  'night-market': 'nightMarket',
  'nano-siege': 'nanoSiege',
  'salvage-crew': 'salvageCrew',
  'wobble-party': 'wobbleParty',
  'dare-district': 'dareDistrict',
  'team-sketch': 'teamSketch',
  'blob-brawl': 'blobBrawl',
  'blaster-bash': 'blasterBash',
  'foam-frenzy': 'foamFrenzy',
  '8-ball-pool': 'eightBall',
  'tilt-rally': 'tiltRally',
  'tile-rummy': 'tileRummy',
  'bobber-bay': 'bobberBay',
  'harvest-hustle': 'harvestHustle',
  'relay-rush': 'relayRush',
  'hill-rush': 'hillRush',
  'tumble-toss': 'tumbleToss',
  'doodle-post': 'doodlePost',
  foosball: 'foosball',
  'snakes-and-ladders': 'snakesAndLadders',
  'two-truths-one-lie': 'twoTruthsAndALie',
  'category-blitz': 'categoryBlitz',
  'sequence-memory': 'sequenceMemory',
  'number-memory': 'numberMemory',
  'pattern-lock': 'patternLock',
  'reflex-duel': 'reflexDuel',
  'neural-path': 'neuralPath',
  'lie-detector': 'lieDetector',
  'shes-a-10-but': 'sheIsA10',
  'empire-game': 'empireGame',
  corebound: 'corebound',
  'marble-rush': 'marbleRush',
  'song-guesser': 'songGuesser',
  'vote-party': 'voteParty',
  charades: 'charades',
  'finish-the-sentence': 'finishTheSentence',
  'cards-hub': 'cardsHub',
  'signal-jam': 'signalJam',
  'blind-spot': 'blindSpot',
};
